module.exports = __webpack_public_path__ + "static/img/slide_3.0fc4dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_3.png
// module id = eOk0
// module chunks = 0